// Auto scroll
// -----------------

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

(function ($) {
    let isScrolling;

    const body = $('body'),
        culturePage = $('.page.page--culture'),
        inBackend = body.hasClass('neos-backend'),
        scrollDelay = 3000; // 3 seconds

    if (inBackend) {
        return;
    }

    if (culturePage.length > 0) {
        $.fn.autoScroll = function () {
            const sections = culturePage.find('section').get(),
                duration = sections.length * 20,

            auto = gsap.timeline({
                repeat: 0
            }).to(window, {
                scrollTo: ScrollTrigger.maxScroll(window),
                delay: .5,
                duration: duration,
                progress: 1,
                ease: 'none',
            });

            window.addEventListener('wheel', () => auto.kill());
            window.addEventListener('touchmove', () => auto.kill());
        };

        culturePage.autoScroll();

        window.addEventListener('wheel', function ( event ) {

            // Clear timeout throughout the scroll
            window.clearTimeout( isScrolling );

            // Set a timeout to run after scrolling ends
            isScrolling = setTimeout(function() {
                $(culturePage).autoScroll();
            }, scrollDelay);

        }, false);
    }
})(jQuery);
